module.exports = __webpack_public_path__ + "glitch-preview-bb9cc15a0102bfaf65712e5cff7e58df.jpg";